export const searchAttributes = [
  {
    field: 'title.synonym',
    weight: 22,
  },
  {
    field: 'title',
    weight: 22,
  },
  {
    field: 'body.synonym',
    weight: 3,
  },
  {
    field: 'body',
    weight: 3,
  },
  {
    field: 'field_title',
    weight: 4,
  },
  {
    field: 'question_title',
    weight: 2,
  },
  {
    field: 'body_processed',
    weight: 1,
  },
];

export const resultAttributes = [
  'url',
  'type',
  'title',
  'body',
  'image_style_uri',
  'field_domain_access',
  'question_title',
  'type_of_answer',
];

export const highlightAttributes = [
  'title',
  'body',
];

export const sorting = {
  default: {
    field: '_score',
    order: 'desc',
  },
};

export const mappedType = (type, title) => {
  switch (type) {
    case 'project':
      return 'Mooi verhaal';
    case 'page':
      return 'Pagina';
    case 'blog':
      return 'Blog';
    case 'guide':
      return 'Handleiding';
    case 'News':
      return 'Nieuws';
    case 'partner':
      return 'Partner';
    case 'landing_page':
      return 'Pagina';
    case 'fonds_op_naam':
      return 'Oranje Fonds op Naam';
    case 'sia_story':
      return 'Verhaal van sociaal initiatief';
    case 'video_selection':
      return 'Video';
    case 'kp_question':
      return null;
    case 'kp_answer':
      return `Vraag: ${title}`;
    default:
      return 'Nieuws';
  }
};
